<template>
  <v-tabs
    v-model="receivedValue"
    v-bind="$attrs"
    :show-arrows="$vuetify.breakpoint.mdAndDown"
    next-icon="$iconCaretRight"
    prev-icon="$iconCaretLeft"
    class="entsys--tabs"
    hide-slider
    :grow="$vuetify.breakpoint.mdAndDown"
    :ripple="false"
    @change="$emit('change', $event)"
  >
    <slot />
  </v-tabs>
  <!--
    <v-menu v-if="showMore" offset-y top>
      <template v-slot:activator="{ on, attrs }">
        <div
          :class="[dropdownOpen ? 'v-tab--active' : '', 'bolded-text v-tab']"
          role="button"
          v-bind="attrs"
          v-on="on"
          @click="dropdownOpen = !dropdownOpen"
        >
          {{ $t("common:tabs.more.label") }}
        </div>
      </template>
      <v-list outlined class="hidden-dropdown-item">
        <v-list-item
          v-for="item in dropdownItems"
          :key="item.index"
          :input-value="
            item.href
              ? receivedValue == item.href.split('#')[1]
              : receivedValue == item.index
          "
          @click="setValue(item)"
        >
          <v-list-item-title>
            <b>{{ item.title }}</b>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    -->
</template>
<script>
//import { ResizeObserver as ResizeObserverPolyFill } from "@juggle/resize-observer";
export default {
  name: "AppTabsCustom",
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    useBackButtonFeature: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showMore: false,
      dropdownOpen: false,
      tabStates: [],
      rand: false,
      init: true,
      observer: null
    };
  },
  computed: {
    receivedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
    // Example problem to why this whole code is commented out:
    // user does refresh on ranking page, then mounted() won't have $slots.default ready and adding any delay is still not reliable
    /*
    dropdownItems() {
      const items = [];
      // Trick to recompute everytime after hideShowTab() called
      if (this.rand || !this.rand) {
        this.tabStates.forEach((x, index) => {
          if (x.inDropdown) items.push(this.tabs[index]);
        });
      }

      return items;
    },
    tabs() {
      return (this.$slots.default || [])
        .map((tab, index) => {
          if (tab.tag && tab.elm) {
            return {
              title: tab.elm.innerText,
              index: index,
              attrs: tab.data.attrs,
              href: tab.elm.href
            };
          }
        })
        .filter(x => x);
    },
    visibleLength() {
      return this.renderedTabs.length;
    },
    totalLength() {
      return this.tabs.length;
    },
    renderedTabs() {
      return Array.from(this.$el.querySelectorAll(".v-tab")).filter(
        el => el.offsetParent
      );
    }*/
  }
  /*
  mounted() {
    // $slots.default are not ready in mounted when user straight up arrives outside of this domain website.
    setTimeout(() => {
      this.$nextTick(() => {
        console.log(this.$slots.default, this.$el.querySelectorAll(".v-tab"));
        const ResizeObserver = window.ResizeObserver || ResizeObserverPolyFill;

        this.observer = new ResizeObserver(() => {
          this.$nextTick(() => {
            const wrapContent = this.$el.querySelector(".v-tabs-bar__content");
            if (wrapContent.clientWidth >= window.innerWidth) this.hide();
            else this.show();
          });
        });

        this.build();
        this.observer.observe(this.$el);
      });
    }, 250);
  },
  methods: {
    setValue(v) {
      if (this.useBackButtonFeature && v.href) {
        const value = v.href.split("#")[1];
        this.receivedValue = value;
        location.hash = "#" + value;
      } else {
        this.receivedValue = v.index;
      }
    },
    build() {
      this.tabs.forEach((x, index) => {
        this.tabStates[index] = {
          inDropdown: false,
          width: this.renderedTabs[index].clientWidth,
          hidAtWidth: 0
        };
      });
    },
    async hide() {
      const wrapContent = this.$el.querySelector(".v-tabs-bar__content");
      // Adding beacue "More" counts
      let inlineSize = wrapContent.clientWidth + 50;

      let el = null;
      let index = this.visibleLength - 1;
      if (index <= 0) index = 0;
      if (this.visibleLength != 0 && inlineSize > window.innerWidth) {
        if (this.init === true) {
          // Run until enough space for rest of the
          while (inlineSize > window.innerWidth) {
            this.showMore = true;
            el = this.renderedTabs[index];
            el.style.display = "none";
            this.tabStates[index].hidAtWidth = window.innerWidth + 50;
            this.tabStates[index].inDropdown = true;
            // Lower index to select next one to be hidden
            index--;
            await this.$nextTick();
            let newWrapContentData = this.$el.querySelector(
              ".v-tabs-bar__content"
            );
            inlineSize = newWrapContentData.clientWidth;
          }
        } else {
          el = this.renderedTabs[index];
          el.style.display = "none";
          this.tabStates[index].hidAtWidth = window.innerWidth + 50;
          this.tabStates[index].inDropdown = true;
        }

        if (this.totalLength > this.visibleLength) this.showMore = true;
      }
      this.init = false;
      this.rand = !this.rand;
    },
    async show() {
      let el = null;
      let index = this.visibleLength - 1;
      if (index <= 0) index = 0;
      console.log(this.renderedTabs[index], index);
      if (index == this.totalLength) {
        el = this.renderedTabs[index];
        el.style.display = "flex";
        this.showMore = false;
        this.tabStates[index].inDropdown = false;
      } else if (
        this.tabStates[index] &&
        this.tabStates[index].hidAtWidth <= window.innerWidth
      ) {
        el = this.renderedTabs[index];
        el.style.display = "flex";
        this.tabStates[index].inDropdown = false;
      }

      this.init = false;
      this.rand = !this.rand;
    }
  }
  */
};
</script>
<style lang="scss">
/*
@media (max-width: 960px) {
  .v-slide-group__prev--disabled {
    display: none !important;
  }
}

.hidden-dropdown-item {
  &.v-list {
    padding-left: 12px;
    padding: 12px;
  }
  .v-list-item {
    text-align: right;
    border-bottom: 2px solid var(--v-secondary-base);
    min-height: 43px !important;
    &:last-child {
      border-bottom: 0;
    }
  }
}

.v-application--is-ltr
  .v-tabs--centered
  > .v-tabs-bar
  .v-tabs-bar__content
  > :first-child:not(.v-tabs-slider-wrapper),
.v-application--is-ltr
  .v-tabs--centered
  > .v-tabs-bar
  .v-tabs-slider-wrapper
  + *,
.v-application--is-ltr
  .v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tabs-bar__content
  > :first-child:not(.v-tabs-slider-wrapper),
.v-application--is-ltr
  .v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tabs-slider-wrapper
  + *,
.v-application--is-rtl
  .v-tabs--centered
  > .v-tabs-bar
  .v-tabs-bar__content
  > :last-child,
.v-application--is-rtl
  .v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tabs-bar__content
  > :last-child {
  margin-left: initial !important;
}*/
</style>
